import { RoomBaseApiService } from "./room.baseapi.service";
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class RoomNoteService extends RoomBaseApiService {
    async saveNote(params) {
        try {
          const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/memo`, {
            ...params
          })
          return new ResponseWrapper(response, response.data)
        } catch (error) {
          throw new ErrorWrapper(error)
        }
      }

    async editNote(params) {
      try {
        const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/${params.memoId}/memo`, {
          ...params
        })
        return new ResponseWrapper(response, response.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    async getNotes() {
      try {
        const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/memo/list`)
        return new ResponseWrapper(response, response.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    async getNote(params) {
      try {
        const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/${params.memoId}/memo`)
        return new ResponseWrapper(response, response.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }
}

export const roomNoteService = new RoomNoteService()